type Persistence = {
  setItem(key: string, value: string): Promise<void>;
  getItem(key: string): Promise<string | null>;
  removeItem(key: string): Promise<void>;
  clear(): Promise<void>;
};

export const persistence: Persistence = {
  setItem(key, value) {
    return new Promise((resolve) => {
      localStorage.setItem(key, value);
      resolve();
    });
  },
  getItem(key) {
    return new Promise((resolve) => {
      const value = localStorage.getItem(key);
      resolve(value);
    });
  },
  removeItem(key) {
    return new Promise((resolve) => {
      localStorage.removeItem(key);
      resolve();
    });
  },
  clear() {
    return new Promise((resolve) => {
      localStorage.clear();
      resolve();
    });
  },
};